import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration, ChartOptions } from 'chart.js';
import { HeaderComponent } from '../../layout/includes/header/header.component';
import { DashService } from '../../../../core/services/dash.service';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { GlobalName } from '../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';

@Component({
    selector: 'app-home',
    imports: [HeaderComponent, CommonModule, RouterModule, BaseChartDirective],
    templateUrl: './home.component.html',
    styleUrl: './home.component.css'
})
export class HomeComponent {

  user:any
  data:any = {}
  loading = false
  loaded = false

  /** Libelle et icone de chaque indicateur renvoye par /dash. */
  readonly tileMeta:any = {
    all_users:           { label: 'Comptes',            icon: 'fa-users',          route: '/admin/users' },
    all_professors:      { label: 'Enseignants',        icon: 'fa-chalkboard-user', route: '/admin/professors/list' },
    all_parents:         { label: 'Parents',            icon: 'fa-user-group',     route: null },
    all_students:        { label: 'Élèves',             icon: 'fa-user-graduate',  route: '/admin/students' },
    students_group:      { label: 'Élèves suivis',      icon: 'fa-school',         route: '/admin/students' },
    inqueries:           { label: 'Préoccupations',     icon: 'fa-comments',       route: '/admin/inqueries/index/pending' },
    health_controls:     { label: 'Contrôles de santé', icon: 'fa-stethoscope',    route: '/admin/infimary-health-controls' },
  }

  lineChartData: ChartConfiguration<'line'>['data'] = { labels: [], datasets: [] }
  lineChartOptions: ChartOptions<'line'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: { y: { beginAtZero: true, ticks: { precision: 0 } } }
  }

  constructor(
    private dashService:DashService,
    private lsService:LocalStorageService
  ) { }

  ngOnInit(): void {
    this.user = this.lsService.get(GlobalName.userName)
    this.getStats()
  }

  getStats(){
    this.loading = true
    this.dashService.getDash().subscribe((res:any)=>{
      this.data = res.data ?? {}
      this.buildChart()
      this.loading = false
      this.loaded = true
    },
    (err:any)=>{
      this.loading = false
      this.loaded = true
      AppErrorShow.showError("Tableau de bord", err)
    })
  }

  /** Indicateurs numeriques effectivement renvoyes pour ce profil. */
  tiles(){
    return Object.keys(this.tileMeta)
      .filter((k)=> this.data[k] !== undefined && this.data[k] !== null)
      .map((k)=> ({ key:k, value:this.data[k], ...this.tileMeta[k] }))
  }

  private buildChart(){
    const g = this.data?.graph_ins
    if (!g?.lineChartLabels?.length) return
    this.lineChartData = {
      labels: g.lineChartLabels,
      datasets: [{
        data: g.lineChartData?.[0]?.data ?? [],
        label: g.lineChartData?.[0]?.title ?? 'Inscriptions',
        fill: true,
        tension: .35,
        borderColor: '#D0312D',
        backgroundColor: 'rgba(208, 49, 45, .12)',
        pointBackgroundColor: '#D0312D'
      }]
    }
  }

  hasChart(){
    return (this.lineChartData.labels?.length ?? 0) > 0
  }

  private isAdminSys(){
    return (this.user?.roles ?? []).some((r:any)=> r?.name === 'adminsys')
  }

  /**
   * Les raccourcis de prise en main ne servent qu'au demarrage : ils ne sont
   * proposes qu'a l'administrateur systeme, et seulement tant qu'aucun eleve
   * n'est inscrit ni rattache a une classe.
   */
  showOnboarding(){
    if (!this.loaded || !this.isAdminSys()) return false
    const s = Number(this.data?.all_students ?? 0)
    const g = Number(this.data?.students_group ?? 0)
    return s === 0 && g === 0
  }
}
